import React, { Fragment, useState } from 'react';
import Project from '../../api/project';
import Link from 'shared/SlashLink';
import usePageSeo from '../../hooks/usePageSeo';
import Header from '../../components/header/Header';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import CtaSection from '../../components/CtaSection/CtaSection';

const PortfolioPage = (props) => {

    usePageSeo({
        title: 'IT Services Portfolio',
        description: 'BUILDLAB IT Services portfolio — managed IT, cyber security, cloud & infrastructure, AI integration, and web engagements for businesses across California.',
        keywords: 'BUILDLAB portfolio, managed IT case studies, cyber security projects, cloud migration, AI integration, IT services',
    });
    const [activeFilter, setActiveFilter] = useState('all');

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const handleFilterClick = (filter) => {
        setActiveFilter(filter);
    }

    // Renders an external <a> (live site) when project.external is set; an internal
    // Link to project.link when set (e.g. a standalone landing page rather than a
    // portfolio-detail page); else the default internal portfolio-detail Link.
    const CardLink = ({ project, className, children }) => (
        project.external
            ? <a href={project.external} target="_blank" rel="noopener noreferrer" className={className}>{children}</a>
            : <Link onClick={ClickHandler} to={project.link || `/portfolio-details/${project.slug}`} className={className}>{children}</Link>
    );

    const FILTERS = [
        { key: 'all', label: 'See All' },
        { key: 'managed-it', label: 'Managed IT' },
        { key: 'cybersecurity', label: 'Cyber Security' },
        { key: 'cloud', label: 'Cloud & Infrastructure' },
        { key: 'ai', label: 'AI Integration' },
        { key: 'web', label: 'Web & Digital' },
    ];

    const filteredProjects = activeFilter === 'all'
        ? Project
        : Project.filter(project => project.category === activeFilter);

    return (
        <Fragment>
            <Header />
            <main id="main-content" className="page_content about-page">
                <PageTitle pageTitle={'Our Portfolio'} pagesub={'Portfolio '} pageTop={'Our'} />
                <section className="portfolio_section section_space bg-light">
                    <div className="container">
                        <div className="filter_elements_nav">
                            <ul className="unordered_list justify-content-center">
                                {FILTERS.map((f) => (
                                    <li key={f.key} className={activeFilter === f.key ? 'active' : ''} onClick={() => handleFilterClick(f.key)}>{f.label}</li>
                                ))}
                            </ul>
                        </div>
                        <div className="filter_elements_wrapper row">
                            {filteredProjects.map((project, prj) => (
                                <div className="col-lg-6" key={prj}>
                                    <div className="portfolio_block portfolio_layout_2">
                                        <div className="portfolio_image">
                                            <CardLink project={project} className="portfolio_image_wrap bg-light">
                                                <img src={project.pImg} alt={`BUILDLAB — ${project.title}`} />
                                            </CardLink>
                                        </div>
                                        <div className="portfolio_content">
                                            <h3 className="portfolio_title">
                                                <CardLink project={project}>
                                                    {project.title}
                                                </CardLink>
                                            </h3>
                                            <ul className="category_list unordered_list">
                                                <li><CardLink project={project}><i className="fa-solid fa-tags" aria-hidden="true"></i> {project.thumb1}</CardLink></li>
                                                <li><CardLink project={project}><i className="fa-solid fa-building" aria-hidden="true"></i> {project.thumb2}</CardLink></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <CtaSection />
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

export default PortfolioPage;
